import React, { useState } from 'react';
import { Button, WithStyles } from '@material-ui/core';
import Card from '@material-ui/core/Card/';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import styles from './styles';
import IntegrationDialog from '../../containers/IntegrationDialog';
import { usePermissions } from '../../hooks/usePermissions';

type Props = WithStyles<typeof styles> & {
  imgSource: string;
  name: string;
  description: string;
};

const IntegrationRequestWidget: React.FC<Props> = props => {
  const [open, setOpen] = useState<boolean>(false);
  const {
    classes, imgSource, name, description,
  } = props;

  const { canEdit } = usePermissions();

  function handleOpen() {
    setOpen(!open);
  }

  return (
    <>
      <IntegrationDialog open={open} changeOpen={handleOpen} integrationName={name} />

      <Card elevation={3} className={classes.card}>
        <CardContent className={classes.cardContent}>
          <div className={classes.logoWrapper}>
            <img style={{ maxHeight: '150px' }} src={imgSource} alt="" className={classes.image} />
          </div>
          <div>
            <Typography className={classes.apiName}>{name}</Typography>
            <Typography className={classes.apiDescription}>
              {description}
            </Typography>
          </div>
          <Typography className={classes.apiAction}>
            <Button
              variant="contained"
              className={classes.controlButton}
              size='large'
              onClick={handleOpen}
              disabled={!canEdit}
            >
              <b>Request</b>
            </Button>
          </Typography>
        </CardContent>
      </Card>
    </>
  );
};

export default React.memo(IntegrationRequestWidget);
